import { useState } from "react";
import classes from "../homePageNew.module.css";
import { WarnIcon, RetryIcon } from "./icons";
import { retryTransaction } from "../api/homePageApi";

/**
 * Port of the prototype's failDetail(), wired to the real retry endpoint
 * (the same one DiscoveryV2/Discovery.js's own retryDiscovery() already
 * calls in production: GET /retry-transaction-request/:transactionId).
 */
export default function FailedRunPanel({ transactionId, failReason, onRetried }) {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    if (!transactionId || retrying) return;
    setRetrying(true);
    try {
      await retryTransaction(transactionId);
      onRetried?.();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className={classes.failDetail}>
      <div className={classes.ic}>
        {retrying ? <span className={classes.retrySpin} /> : <WarnIcon size={22} />}
      </div>
      <div className={classes.t1}>{retrying ? "Retrying this run…" : "This run failed"}</div>
      <div className={classes.t2}>
        {retrying
          ? "Re-running with the same configuration. This usually takes under a minute."
          : failReason || "An unknown error occurred during data collection."}
      </div>
      {!retrying && (
        <div className={classes.btnrow}>
          <button className={classes.retryBtn} onClick={handleRetry}>
            <RetryIcon size={13} /> Retry Run
          </button>
        </div>
      )}
    </div>
  );
}
